module.exports = __webpack_public_path__ + "static/media/bronze.d8ff9f13.png";